module.exports = __webpack_public_path__ + "img/logo.7adfb1a6.png";